import { esc } from "./format";
import { L } from "./i18n";
// イベントページの「追加の画像」（コース図・席種図など。最大6枚）。画像は切らずに全体を見せ、押すと原寸を新しいタブで開く
export interface GalleryImage { url: string; caption: string }
// 取り込んだ画像の URL だけを出す（サーバーでも保存時に同じ検査をしている）
const SAFE = /^https:\/\/storage\.googleapis\.com\/[a-z0-9._-]+\/events\/[A-Za-z0-9-]+\.(jpg|png|webp)$/;
export function galleryHtml(list: GalleryImage[] | undefined, eventName: string): string {
  const items = (list ?? []).filter((g) => SAFE.test(g?.url ?? ""));
  if (!items.length) return "";
  return `<section class="gallery">${items.map((g, i) => `<figure>
      ${g.caption ? `<h3>${esc(g.caption)}</h3>` : ""}
      <a href="${esc(g.url)}" target="_blank" rel="noopener" aria-label="${L(`${esc(g.caption || `${eventName}の画像${i + 1}`)}を原寸で開きます`, `Open ${esc(g.caption || `image ${i + 1} of ${eventName}`)} in full size`)}"><img src="${esc(g.url)}" alt="${esc(g.caption || L(`${eventName}の画像${i + 1}`, `Image ${i + 1} of ${eventName}`))}" loading="lazy"></a>
      <figcaption class="meta">${L("画像を押すと原寸でご覧いただけます", "Tap the image to view it in full size")}</figcaption></figure>`).join("")}</section>`;
}
